import React, { lazy } from 'react';
import { AppRoute } from '../routes.types';

const SharePage = lazy(() => import('../../venues/pages/SharePage/SharePage'));
const MyReferals = lazy(() => import('../../containers/Referal/MyReferals'));
const Withdraw = lazy(() => import('../../containers/Referal/Withdraw'));
const Donate = lazy(() => import('../../containers/Referal/Donate'));
const CharityEdit = lazy(() => import('../../containers/Referal/CharityEdit'));
const Charity = lazy(() => import('../../containers/Referal/Charity'));
const PracticeRequests = lazy(() => import('../../containers/PracticeRequests/PracticeRequests'));
const ReferralRequests = lazy(() => import('../../containers/ReferralRequests/ReferralRequests'));

export const SHARE_ROUTES: AppRoute[] = [
    { path: '', element: <SharePage /> },
    { path: 'my-referrals', element: <MyReferals /> },
    { path: 'withdraw', element: <Withdraw type="user" /> },
    { path: 'charities', element: <Charity /> },
    { path: 'charities/:id/edit', element: <CharityEdit /> },
    { path: 'charities/:id/withdraw', element: <Withdraw type="charity" /> },
    { path: 'donate', element: <Donate type="donation" /> },
    { path: 'nonprofits', element: <Donate type="nonprofits" /> },
    { path: 'practice-requests', element: <PracticeRequests /> },
    { path: 'referral-requests', element: <ReferralRequests /> },
];
